import "@/assets/scss/iconfont/iconfont.css";
import App from "./App.vue";
import router from "@/vue/router/";
import Vuelidation from "@/vue/plugins/vuelidation";
import valid from "@/vue/mixin/valid";
import VueCountdown from "@/vue/plugins/vue-countdown";
import VueBus from 'vue-bus';
import AMap from 'vue-amap';
import vueSignature from "vue-signature";
import VueAwesomeSwiper from 'vue-awesome-swiper';
import vueResource from 'vue-resource';
import "swiper/css/swiper.css";
import store from "./vue/store";

import { formatPrice } from "@/assets/js/util.js";
// import 'swiper/dist/css/swiper.css'
// import 'vant/lib/vant-css/index.css'

//babel-polyfill
import "babel-polyfill";
import {
    Lazyload,
    Toast,
    Tag,
    Dialog,
    Cell,
    CellGroup,
    Field,
    Icon,
    Button,
    Popup,
    loading,
    List,
    Row,
    Col,
    Area,
    Picker,
    ActionSheet,
    NoticeBar,
    Tab,
    Tabs,
    Swipe,
    SwipeItem,
    Rate,
    ImagePreview,
    Steps,
    Step,
    RadioGroup,
    Radio,
    DatetimePicker,
    Calendar,
    Checkbox,
    CheckboxGroup,
    Overlay,
    CountDown,
    Stepper,
    PullRefresh
} from "vant";

import axios from "@/vue/plugins/axios";
import util from "@/assets/js/util";
import filters from "@/vue/filter/";
import myTouch from '@/assets/js/myTouch'
myTouch(Vue)
var qiniu = require('qiniu-js')

// plugins
Vue.use(VueCountdown);
Vue.use(axios);
Vue.use(Vuelidation);
Vue.use(valid);
Vue.use(VueAwesomeSwiper);
Vue.use(vueResource)
Vue.use(filters);
Vue.use(util);
Vue.use(VueBus);
Vue.use(AMap);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(DatetimePicker).use(Calendar)

//map

AMap.initAMapApiLoader({
    key: 'bd7d0d2c0d49531b7715da3615bab507',
    plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType']
})
Vue.use(Lazyload, {
    preLoad: 1.3,
    error: "/static/img/goods_default.jpg",
    loading: "/static/img/goods_default.jpg",
    attempt: 1,
    lazyComponent: true,
});
Vue.use(qiniu);
Vue.use(Tag).use(Cell).use(CellGroup).use(Field).use(Icon).use(Button).use(Popup).use(loading).use(List).use(Row).use(Col).use(Area).use(Picker).use(ActionSheet).use(NoticeBar).use(Tabs).use(Tab).use(Swipe).use(SwipeItem).use(Rate).use(ImagePreview).use(Dialog).use(Steps).use(Step).use(Overlay).use(CountDown).use(Stepper);
Vue.use(Checkbox).use(CheckboxGroup).use(PullRefresh)
Toast.setDefaultOptions({
    duration: 1500
});

Vue.use(vueSignature);


Vue.config.devtools = true;
Vue.prototype.$formatPrice = formatPrice
//FastClick.attach(document.body);
new Vue({
    el: "#app",
    router,
    store,
    render: h => h(App)
});
document.setTitle = function (t) {
    document.title = t;
    var i = document.createElement("iframe");
    i.src = "//m.baidu.com/favicon.ico";
    i.style.display = "none";
    i.onload = function () {
        setTimeout(function () {
            i.remove();
        }, 9);
    };
    document.body.appendChild(i);
};
router.afterEach((to, from, next) => {
    Dialog.close();
});